var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Navigation / Sidebar Compact / Components / Category Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.-Work-Orders-/-02.-Scoping-/-Offline-Mode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(-25.000000, -832.000000)",
    fill: "#1C4775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-Sidebar-Compact-/-Components-/-Category-Copy-7",
    transform: "translate(23.000000, 830.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,12 C18,8.69 15.31,6 12,6 C8.69,6 6,8.69 6,12 C6,14.22 7.21,16.15 9,17.19 L10,15.45 C8.81,14.75 8,13.48 8,12 C8,9.79 9.79,8 12,8 C14.21,8 16,9.79 16,12 C16,13.48 15.19,14.75 14,15.45 L15,17.19 C16.79,16.15 18,14.22 18,12 Z M12,2 C6.48,2 2,6.48 2,12 C2,15.7 4.01,18.92 6.99,20.65 L7.99,18.92 C5.61,17.53 4,14.96 4,12 C4,7.58 7.58,4 12,4 C16.42,4 20,7.58 20,12 C20,14.96 18.39,17.53 16,18.92 L17,20.65 C19.99,18.92 22,15.7 22,12 C22,6.48 17.52,2 12,2 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,10 C10.9,10 10,10.9 10,12 C10,13.1 10.9,14 12,14 C13.1,14 14,13.1 14,12 C14,10.9 13.1,10 12,10 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.7df1363f76d508edc962e0ec3bf2ab3b.svg";
export { ForwardRef as ReactComponent };